module.exports = __webpack_public_path__ + "img/dummy_icon.e24e58e3.png";